import { render, staticRenderFns } from "./PasswordWidget.vue?vue&type=template&id=4e97d8ee&scoped=true&"
import script from "./PasswordWidget.vue?vue&type=script&lang=js&"
export * from "./PasswordWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e97d8ee",
  null
  
)

export default component.exports